import ract1 from '../../assets/images/dashboard/Rectangle-26.jpg';
import ract2 from '../../assets/images/dashboard/Rectangle-27.jpg';
import ract3 from '../../assets/images/dashboard/Rectangle-28.jpg';
import ract4 from '../../assets/images/dashboard/Rectangle-29.jpg';
import ract5 from '../../assets/images/dashboard/Rectangle-28.jpg';
import boy from '../../assets/images/avtar/boy.png';
import girl from '../../assets/images/avtar/girl.png';
import man from '../../assets/images/avtar/man.png';
import women from '../../assets/images/avtar/woman.png';
import nike from '../../assets/images/dashboard-2/running-shoe.png';
import bag from '../../assets/images/dashboard-2/hand-bag.png';
import glass from '../../assets/images/dashboard-2/sun-glasses.png';
import shirt from '../../assets/images/dashboard-2/shirt.png';

export const NewsUpdate = [
    {
        id: 1,
        img: ract1,
        title: 'Google Project Apply Review',
        desp: 'Todays News Headlines, Breaking...',
        time: '1 day ago'
    },
    {
        id: 2,
        img: ract2,
        title: 'Business Logo Create',
        desp: 'Check out the latest news from...',
        time: '2 weeks ago'
    },
    {
        id: 3,
        img: ract3,
        title: 'Business Project Research',
        desp: 'News in English: Get all Breaking...',
        time: '3 day ago'
    },
    {
        id: 4,
        img: ract4,
        title: 'Recruitment in it Department',
        desp: 'Technology and Indian Business News...',
        time: '2 hours ago'
    },
    {
        id: 5,
        img: ract5,
        title: 'Business Project Research',
        desp: 'News in English: Get all Breaking...',
        time: '3 day ago'
    }
];

export const OutGoing = [
    {
        id: 1,
        img: boy,
        img2: nike,
        name: 'Gary',
        name1: 'Nike Sports NK',
        team: 'UK Design Team',
        date: '12 May 2022',
        time: 'In 6 Days',
        title: 'Product Design',
        title1: 'Free delivery',
        prize: '$7,800',
        class: 'badge badge-light-primary',
        status: 'Done',
        qty: '78'
    },
    {
        id: 2,
        img: girl,
        img2: bag,
        name: 'Ralph Waters',
        name1: 'Women Bag',
        team: ' UX Ninjas',
        date: '06 May 2022',
        time: 'Overdue',
        title: 'Concept Design',
        title1: '₹83.65 delivery',
        prize: '$670',
        class: 'badge badge-light-secondary',
        status: 'Pending',
        qty: '25'
    },
    {
        id: 3,
        img: man,
        img2: glass,
        name: 'Edwin Day',
        name1: 'Sunglasses',
        team: ' SF Dev Team',
        date: '28 Sep 2022',
        time: 'in 4 Months',
        title: 'UX Consulting',
        title1: 'Free delivery',
        prize: '$7,889',
        class: 'badge badge-light-danger',
        status: 'Rejected',
        qty: '36'
    },
    {
        id: 4,
        img: women,
        img2: shirt,
        name: 'Gary',
        name1: 'Cotton T-shirt',
        team: ' UK Design Team',
        date: '12 May 2022',
        time: 'In 6 Days',
        title: 'Product Design',
        title1: '₹83.65 delivery',
        prize: 'Toyota',
        class: 'badge badge-light-info',
        status: 'In Progress',
        qty: '85'
    }
];